import { createContext, Dispatch, SetStateAction } from "react";

// Define the shape of a single chat message
interface ChatMessage {
  text: string;
  isBot: boolean;
  chartImage?: string;
  questionCategory?: string;
  embeddedQuestion?: string;
}

// Define the shape of the context value
export interface AppContextType {
  chatMessages: ChatMessage[];
  setChatMessages: Dispatch<SetStateAction<ChatMessage[]>>;
  chatHistory: any[];
  setChatHistory: Dispatch<SetStateAction<any[]>>;
  // --- NEW: Add state for submitted feedback ---
  submittedFeedback: number[];
  setSubmittedFeedback: Dispatch<SetStateAction<number[]>>;
  // Selected chat subject (e.g. "C40", "IPCC", "glueup"). Persisted here so
  // it survives navigation away and back to /prompt — otherwise the dropdown
  // resets to the default while chat history (which lives here too) sticks
  // around, leading to messages being sent against the wrong backend path.
  currentSubject: string;
  setCurrentSubject: Dispatch<SetStateAction<string>>;
  user: any;
  setUser: (user: any) => void;
  surveyResult: any[];
  setSurveyResult: (result: any[]) => void;
}

// Create the context with a default value
const AppContext = createContext<AppContextType | null>(null);

export default AppContext;